/**
 * rb-image-skeleton
 *
 * Marks every <img> on the page as loading until it actually loads, so the
 * CSS skeleton (Rainbow wordmark on cream pulse) is shown by default and
 * hidden via the `rb-loaded` class once the image is ready.
 *
 * Also watches the DOM (MutationObserver) so dynamically inserted images
 * (Alpine renders, AJAX cart drawer, section reloads, etc.) get the same
 * treatment without a flash of unbranded grey.
 */
(function () {
  "use strict";

  function markLoaded(img) {
    if (img.classList.contains("rb-loaded")) return;
    img.classList.add("rb-loaded");
  }

  function watch(img) {
    if (!img || img.tagName !== "IMG") return;
    if (img.complete && img.naturalWidth > 0) { markLoaded(img); return; }
    img.addEventListener("load", function () { markLoaded(img); }, { once: true });
    img.addEventListener("error", function () { markLoaded(img); }, { once: true });
  }

  function scan(root) {
    var imgs = (root || document).querySelectorAll ? (root || document).querySelectorAll("img") : [];
    for (var i = 0; i < imgs.length; i++) watch(imgs[i]);
  }

  function init() {
    scan(document);
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (!n) continue;
            if (n.tagName === "IMG") watch(n);
            else if (n.querySelectorAll) scan(n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (_) { /* ignore */ }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
